import { ApplicationDto } from 'application/interfaces/pegasus.gateway';
import React from 'react';
import styled from 'styled-components';

import { DescomplicaLogo } from './descomplica-logo';

interface LogoWrapperProps {
  application: ApplicationDto;
}

const Container = styled.div`
  width: max-content;
  display: flex;
  align-items: center;
`;

const OrganizationLogoWrapper = styled.div`
  display: flex;
  align-items: center;
  padding-left: 41px;
  position: relative;

  &::before {
    content: ' x ';
    position: absolute;
    color: #fff;
    left: 0;
    padding-left: 16px;
    font-weight: bold;
  }
`;

const OrganizationLogo = styled.img`
  height: 32px;
`;

export const LogoWrapper = ({ application }: LogoWrapperProps) => {
  return (
    <Container>
      <DescomplicaLogo height="24px" />
      {application.organization.logo && (
        <OrganizationLogoWrapper>
          <OrganizationLogo src={application.organization.logo} />
        </OrganizationLogoWrapper>
      )}
    </Container>
  );
};
